import clsx from "clsx";
import React from "react";
import * as styles from "./svg-icon.css";

export type SVGIconName =
    | "account-icon"
    | "basket-icon"
    | "bell"
    | "bell-empty"
    | "show-on"
    | "show-off"
    | "big-arrow-pdp-emo"
    | "cart"
    | "chevron"
    | "chevron-thin"
    | "clear"
    | "cross"
    | "cross-thin"
    | "close"
    | "discount"
    | "external-link"
    | "expand-pdp"
    | "fat-arrow"
    | "filters"
    | "heart"
    | "heart-broken"
    | "preview-icon"
    | "hyperlink"
    | "minus"
    | "plus"
    | "plus-thin"
    | "round-minus"
    | "round-plus"
    | "plus-bag"
    | "price-drop"
    | "search"
    | "sort"
    | "tag"
    | "tick"
    | "tick-new"
    | "truck"
    | "lysts-search"
    | "lysts-control"
    | "lysts-recommendations"
    | "value-proposition-search"
    | "value-proposition-shopping-bag"
    | "value-proposition-star"
    | "saved-search"
    | "saved-search-empty"
    | "saved-search-bookmark"
    | "stopwatch"
    | "tap-hand"
    | "mail-plane"
    | "magnify"
    | "heart-empty"
    | "round-chevron"
    | "alert-new"
    | "heart-unpressed"
    | "heart-pressed"
    | "basket-new"
    | "user"
    | "expand"
    | "round-radiobutton"
    | "round-radiobutton-checked"
    | "round-checkbox"
    | "round-checkbox-bold"
    | "round-checkbox-checked"
    | "icon-bulb"
    | "round-select-marker"
    | "square-chevron"
    | "square-chevron-thin"
    | "chevron-medium"
    | "arrow-icon"
    | "shoppingbag-icon"
    | "search-light-grey"
    | "searches-icon"
    | "searches-icon-filled"
    | "searches-icon-empty"
    | "alerts-icon"
    | "user-icon"
    | "twitter"
    | "facebook"
    | "facebook-icon"
    | "apple-icon"
    | "google-icon"
    | "instagram"
    | "pinterest"
    | "info-icon"
    | "heart-icon-empty"
    | "heart-icon-filled"
    | "arrow-right"
    | "arrow-left"
    | "arrow-down"
    | "qr-icon"
    | "stars"
    | "icon-smiley"
    | "padlock"
    | "error"
    | "lyst-app-icon"
    | "warning-icon";

interface SVGIconProps {
    name: SVGIconName;
    className?: string;
    overrideStyle?: boolean;
    title?: string;
}

interface SVGIconRotateProps extends SVGIconProps {
    rotate?: number;
}

interface SVGIconFlipProps extends SVGIconProps {
    flip?: boolean;
}

export function SVGIcon({
    name,
    className,
    overrideStyle,
    title,
    ...props
}: SVGIconRotateProps | SVGIconFlipProps): React.ReactElement {
    let inlineStyles = {};
    if ("rotate" in props) {
        inlineStyles["transform"] = `rotate(${props.rotate}deg)`;
    } else if ("flip" in props) {
        inlineStyles["transform"] = "rotateY(180deg)";
    }

    return (
        <svg
            data-testid="icon"
            style={inlineStyles}
            aria-hidden="true"
            className={clsx(!overrideStyle && styles.icon, `svg-icon-${name}`, className)}
        >
            {title && <title>{title}</title>}
            <use xlinkHref={`#${name}`} />
        </svg>
    );
}

export default SVGIcon;
